import React from "react";
import { SkeletonListMultiLine } from "../../Skeleton/SkeletonListMultiLine.js";
import { SkeletonListKeyValue } from "../../Skeleton/SkeletonListKeyValue.js";
import useUserAgent from "../../../../hooks/useUserAgent.js";
import styles from "./FlightsContentSkeleton.module.css";
import { mcn } from "../../../../utils/mergeClassnames.js";
const FlightsContentSkeleton = () => {
    const { isMobile } = useUserAgent();
    return (React.createElement("div", { className: mcn(isMobile && styles.skeletonWrapper) },
        React.createElement("div", { className: isMobile ? styles.skeletonSpacer : styles.skeletonSpacerDesktop },
            React.createElement(SkeletonListKeyValue, { amount: 4 })),
        React.createElement("div", { className: isMobile ? styles.skeletonSpacer : styles.skeletonSpacerDesktop },
            React.createElement(SkeletonListKeyValue, { amount: 4 })),
        React.createElement("div", { className: isMobile ? styles.skeletonSpacer : styles.skeletonMarginDesktop },
            React.createElement(SkeletonListMultiLine, { amount: 2 }))));
};
export default FlightsContentSkeleton;
